<!-- OLD Rewardship Rules -->

<!-- <div class="rewardship-rules-dialog ups-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{'RewardShipRules'|translate}}</h2>
    <mat-dialog-actions>      
    </mat-dialog-actions>
    <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <ul>
      <li>
        {{'RewardshipList.ListItem1'|translate}}
      </li>
      <li>
        {{'RewardshipList.ListItem2.MessagePart1'|translate}} {{'RewardshipList.ListItem2.Link'|translate}}.
      </li>
      <li>
        {{'RewardshipList.ListItem3'|translate}}
      </li>
      <li>{{'RewardshipList.ListItem4'|translate}}</li>
      <li>{{'RewardshipList.ListItem5'|translate}}</li>
      <li>{{'RewardshipList.ListItem6'|translate}}</li>
      <li>{{'RewardshipList.ListItem7'|translate}}</li>
      <li>{{'RewardshipList.ListItem8'|translate}}</li>
      <li>{{'RewardshipList.ListItem9'|translate}}</li>
      <li>{{'RewardshipList.ListItem10'|translate}}</li>
      <li>{{'RewardshipList.ListItem11'|translate}}</li>
      <li>{{'RewardshipList.ListItem12.MessagePart1'|translate}} <a href="mailto:accounting@parcelpro.com">{{'RewardshipList.ListItem12.Link'|translate}}</a>.
        {{'RewardshipList.ListItem12.MessagePart2'|translate}}</li>
      <li>{{'RewardshipList.ListItem13'|translate}}</li>
      <li>{{'RewardshipList.ListItem14'|translate}}</li>
      <li>{{'RewardshipList.ListItem15'|translate}}</li>
      <li>{{'RewardshipList.ListItem16'|translate}}</li>
      <li>{{'RewardshipList.ListItem17'|translate}}</li>
    </ul>
  </mat-dialog-content>
</div> -->



<!-- NEW Rewardship Rules  -->
<div class="dialog">
  <div class="close"><mat-icon (click)="close()">close</mat-icon></div>
  <div class="frame">
  <div class="headline">
      <div class="headline-text">{{'RewardShipRules'|translate}}</div>
      <div class="keyline"></div>
  </div>
  </div>
      <div class="text">
        <ul>
          <li>{{'RewardshipList.ListItem1'|translate}} </li>
          <li> {{'RewardshipList.ListItem2.MessagePart1'|translate}} {{'RewardshipList.ListItem2.Link'|translate}}. </li>
          <li> {{'RewardshipList.ListItem3'|translate}}</li>
          <li>{{'RewardshipList.ListItem4'|translate}}</li>
          <li>{{'RewardshipList.ListItem5'|translate}}</li>
          <li>{{'RewardshipList.ListItem6'|translate}}</li>
          <li>{{'RewardshipList.ListItem7'|translate}}</li>
          <li>{{'RewardshipList.ListItem8'|translate}}</li>
          <li>{{'RewardshipList.ListItem9'|translate}}</li>
          <li>{{'RewardshipList.ListItem10'|translate}}</li>
          <li>{{'RewardshipList.ListItem11'|translate}}</li>
          <li>{{'RewardshipList.ListItem12.MessagePart1'|translate}} <a href="mailto:accounting@parcelpro.com">{{'RewardshipList.ListItem12.Link'|translate}}</a>. 
            {{'RewardshipList.ListItem12.MessagePart2'|translate}}</li>
          <li>{{'RewardshipList.ListItem13'|translate}}</li>
          <li>{{'RewardshipList.ListItem14'|translate}}</li>
          <li>{{'RewardshipList.ListItem15'|translate}}</li>
          <li>{{'RewardshipList.ListItem16'|translate}}</li>
          <li>{{'RewardshipList.ListItem17'|translate}}</li>
        </ul>
       </div>
</div>
